import { createIcon } from '@chakra-ui/react';

export const Bell = createIcon({
  displayName: 'Bell',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect id="bg" width="24" height="24" fill="#fff" />
      <path
        id="Bell_-_L-2"
        data-name="Bell - L"
        d="M18.458,21.909a.568.568,0,0,0-.663.446,1.261,1.261,0,0,1-2.476,0,.568.568,0,0,0-.67-.446.56.56,0,0,0-.446.659,2.389,2.389,0,0,0,4.693,0A.56.56,0,0,0,18.458,21.909ZM12.393,5.5a7.7,7.7,0,0,0-2.358,2.846.568.568,0,0,0,.27.762.61.61,0,0,0,.24.053.571.571,0,0,0,.514-.324,6.5,6.5,0,0,1,2.011-2.427.565.565,0,1,0-.678-.9ZM15.06,4.134a9.467,9.467,0,0,0-1.173.469.564.564,0,1,0,.488,1.017,7.749,7.749,0,0,1,1.036-.408.566.566,0,1,0-.343-1.078Zm10.933,15-.8-2.625V9.563c.008-3.608-2.926-6.625-6.842-7.341a1.791,1.791,0,0,0-.518-1.181,1.813,1.813,0,0,0-2.56,0,1.771,1.771,0,0,0-.518,1.181c-3.916.716-6.85,3.733-6.85,7.341a.876.876,0,0,0,0,.133v6.8a.137.137,0,0,1,0,.042l-.792,2.6a1.078,1.078,0,0,0,.13.99,1.284,1.284,0,0,0,1.07.549h16.48a1.291,1.291,0,0,0,1.07-.549,1.086,1.086,0,0,0,.13-.99Zm-1.2.411H8.313a.446.446,0,0,1-.141-.03h0v-.042l.789-2.594a1.116,1.116,0,0,0,.065-.381V9.563c.008-3.531,3.383-6.381,7.528-6.381s7.52,2.85,7.516,6.4v6.926a1.116,1.116,0,0,0,.065.381l.8,2.6a.179.179,0,0,1-.141.053Z"
        transform="translate(-4.422 -0.512)"
        fill="currentColor"
      />
    </>
  ),
});
